import { render } from "./SectionWrapper.vue?vue&type=template&id=0bb43f22"
import script from "./SectionWrapper.vue?vue&type=script&lang=js"
export * from "./SectionWrapper.vue?vue&type=script&lang=js"

import "./SectionWrapper.vue?vue&type=style&index=0&id=0bb43f22&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__